<template>
  <ac-modal :title="'Add New Primary Member'" ref="modalRef">
    <template v-if="widgetReady">
      <div class="row form-group">
        <div class="info-board info-board-blue">
          <h4>General Information</h4>
          <p>Members are responsible for setting up and managing their profile.</p>
        </div>
      </div>
      <generic-profile-info v-model="model.contactInfo"></generic-profile-info>
      <div class="row">
        <div class="col-lg-4 form-group">
          <label>Social Security Number</label>
          <small v-if="ssnRequired" class="redText">required</small>
          <ac-social-security-number v-model="model.mainModel.ssn"></ac-social-security-number>
        </div>
        <div class="col-lg-4 form-group">
          <label>DOB <small class="redText">required</small></label><br/>
          <ac-date-picker v-model="model.mainModel.birthDate"></ac-date-picker>
        </div>
        <div class="col-lg-4 form-group">
          <label>Benefits Start On</label><br/>
          <ac-date-picker v-model="model.mainModel.effStartDate"></ac-date-picker>
        </div>
        <div class="col-lg-12">
          <h4>Home Address</h4>
          <ac-address v-model="model.mainModel.address"></ac-address>
        </div>
        <div class="col-lg-12">
          <add-dependent ref="addDependents" :ssn-required="ssnRequired" :company-id="companyId"></add-dependent>
        </div>
      </div>
    </template>
    <template slot="buttons">
      <ac-button class="btn btn-red btn-sm" :action="cancel">CANCEL</ac-button>
      <ac-button class="btn btn-green btn-sm" href="#" role="button" :action="saveConsumer">
        SAVE
      </ac-button>
    </template>
  </ac-modal>
</template>

<script>
import GenericProfileInfo from "../../../components/shared/GenericProfileInfo.vue";
import {api} from "../../../global/framework/api.js";
import AcButton from "../../../global/customHtmlElements/AcButton.vue";
import AcAddress from "../../../components/custom/AcAddress.vue";
import AcCoverageDropDown from "../../../components/custom/AcCoverageDropDown.vue";
import {formatter} from "../../../global/formatter.js";
import AddDependent from "../../../components/shared/consumer/AddDependent.vue";

let template = null;
export default {
  name: "AddEmployeeModal",
  components: {AddDependent, AcCoverageDropDown, AcAddress, AcButton, GenericProfileInfo},
  data() {
    return {
      widgetReady: false,
      dynamicKey: 0,
      companyId: 0,
      model: {},
      spouse: {},
      children: [],
      ssnRequired: false
    };
  },
  methods: {
    async showModal(companyId) {
      this.companyId = companyId;
      await this.init();
      this.$refs.modalRef.open();
    },
    async init() {
      if (template == null) {
        template = await api.getData("Company", this.companyId, "GetCreateEmployeeTemplate");
        template.effStartDate = formatter.getDateForDatePicker();// Default to Today's date
      }
      this.mapData('model', template.consumerWizardVM);
      this.ssnRequired = !!template.ssnRequired;
      this.widgetReady = true;
    },
    async saveConsumer() {
      let self = this;
      let allDependents = this.$refs.addDependents.getAllDependents();
      let spouse = allDependents.filter(dependent => dependent.isSpouse == true);
      let children = allDependents.filter(dependent => dependent.isSpouse != true);
      this.spouse = spouse[0];
      this.children = children;
      let data = {
        consumerWizardVm: this.model, spouse: this.spouse ? this.spouse : null,
        children: this.children, companyId: this.companyId, token: null,
        profileCompletedByEmployer: true
      };
      let result = await api.postDataAsJson("Company", "CreateEmployee", data);
      if (result) {
        self.$refs.modalRef.close();
        self.$bus.$emit(self.$bus.$AcEvents.EMPLOYEE_ADDED, result);
      }
    },
    cancel() {
      this.$refs.modalRef.close();
    }
  }
}
</script>
<style scoped></style>